module.exports = __webpack_public_path__ + "static/media/booking.a4e34942.png";